import { observable } from "mobx";
import DistributorPurchaseStatus from "./distributorPurchaseStatus";
import DistributorPurchaseType from "./distributorPurchaseType";
import DistributorTypeNew from "./distributorTypeNew";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class DistributorSimpleListResponse {
  /**
   * Payment template ID.
   */
  id!: string;

  /**
   * Payment template code.
   */
  @observable
  name!: string;

  /**
   * Payment template code.
   */
  @observable
  shortName!: string;

  /**
   * Distributor type.
   */
  @observable
  type!: DistributorTypeNew;

  /**
   * Distributor purchase type.
   */
  @observable
  purchaseType!: DistributorPurchaseType;

  /**
   * Distributor purchase status.
   */
  @observable
  purchaseStatus!: DistributorPurchaseStatus;
}
